var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprites.a00ae3889e9a3632b3c6e219e715d304.svg#poi--heNNn';
                    var viewUrl = 'sprites.a00ae3889e9a3632b3c6e219e715d304.svg#view-poi--heNNn';

                    

                    module.exports = {
                        url: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 17 22',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };